import gql from 'graphql-tag';

export const deleteWaitingListItem = gql`
  mutation deleteWaitingListItem($input: DeleteWaitingListItemInput!) {
    deleteWaitingListItem(input: $input) {
      start
    }
  }
`;
